var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCallback, useMemo } from 'react';
import { BrowserEntryType } from '@lucidlink/uicore';
import { useBrowserSearch, useMemFileBrowserStore, useWebFsNavigation, } from '#hooks';
import { useFilespaceById } from '#query-hooks';
import { FILE_BROWSER_INSTANCE } from '#telemetry';
import { buildPickerEntries } from './FsEntryPicker.services';
const ROOT_CRUMBS_COUNT = 1;
export const useFsEntryPicker = ({ filespaceId, workspaceId, }) => {
    _react_refresh_temp_1();
    const { currentDirId, setCurrentDirId } = useMemFileBrowserStore();
    const { search, setSearch } = useBrowserSearch({
        browserInstance: FILE_BROWSER_INSTANCE.FsEntryPicker,
        currentDirId,
        filespaceId,
        workspaceId,
    });
    const { query: { data: filespaceData, isError: isFilespaceError, isFetching: isFilespaceFetching, isPending: isFilespacePending, refetch: refetchFilespace, }, } = useFilespaceById(workspaceId, filespaceId);
    const { changeCurrentDir, crumbs, currentDirContents, currentDirPath, filespaceRootKey, isCrumbsError, isCrumbsPending, isError: isNavigationError, isPending: isNavigationPending, isRetrying: isNavigationRetrying, retry: retryNavigation, } = useWebFsNavigation({
        browserInstance: FILE_BROWSER_INSTANCE.FsEntryPicker,
        currentDirId,
        filespaceId,
        rootName: filespaceData?.name ?? '',
        setCurrentDirId,
        workspaceId,
    });
    const entries = useMemo(() => buildPickerEntries({
        crumbs,
        currentDirContents,
        filter: search,
    }), [crumbs, currentDirContents, search]);
    const isInRoot = (crumbs?.length ?? 0) <= ROOT_CRUMBS_COUNT;
    const currentDirSelection = useMemo(() => {
        const currentCrumb = crumbs?.at(-1);
        const currentDirSelectionId = currentDirId || filespaceRootKey?.id;
        if (!currentCrumb ||
            !currentDirSelectionId ||
            currentDirPath === undefined) {
            return undefined;
        }
        return {
            id: currentDirSelectionId,
            name: currentCrumb.name,
            path: currentDirPath,
            type: BrowserEntryType.DIR,
        };
    }, [crumbs, currentDirId, currentDirPath, filespaceRootKey?.id]);
    const retry = useCallback(() => {
        if (isFilespaceError) {
            void refetchFilespace();
        }
        if (isNavigationError) {
            retryNavigation();
        }
    }, [
        isFilespaceError,
        isNavigationError,
        refetchFilespace,
        retryNavigation,
    ]);
    return {
        changeCurrentDir,
        crumbs: crumbs ?? [],
        currentDirId,
        currentDirPath: currentDirPath ?? '',
        currentDirSelection,
        entries,
        isCrumbsError,
        isCrumbsPending,
        isFilespaceError,
        isInRoot,
        isLoading: isFilespacePending || isNavigationPending,
        isNavigationError,
        isRetrying: isNavigationRetrying || (isFilespaceError && isFilespaceFetching),
        retry,
        search,
        setSearch,
    };
};
_react_refresh_temp_1(useFsEntryPicker, "SqnkHYryXuPM38NNYgZFW6kdWBQ=", false, () => [useMemFileBrowserStore, useBrowserSearch, useFilespaceById, useWebFsNavigation]);
